<template>
  <v-container :class="['container', {'shrink': sidebarVisible}]">
    <!-- The sidebar with the pivot and the selected items -->
    <v-sidebar />
    <!-- The results -->
    <v-slide-y-reverse-transition>
      <div v-if="pivotItems.length && !loadingPivotItems">
        <!-- The header of the results -->
        <v-similar-header />
        <!-- The results itself -->
        <v-similar-items />
        <!-- The pagination of the items -->
        <v-similar-items-pagination />
        <v-infinite-items-save-button />
      </div>
    </v-slide-y-reverse-transition>
    <!-- An aside card with instruction to create individual qmps -->
    <v-individual-qmps-card />
    
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import VIndividualQmpsCard from "../../components/IndividualQmpsCard";
import VSidebar from "./Sidebar";
import VSimilarHeader from "./SimilarHeader";
import VSimilarItems from "./SimilarItems";
import VSimilarItemsPagination from "./SimilarItemsPagination";
import VInfiniteItemsSaveButton from "./InfiniteItemsSaveButton";

export default {
  components: {
    VIndividualQmpsCard,
    VSidebar,
    VSimilarHeader,
    VSimilarItems,
    VSimilarItemsPagination,
    VInfiniteItemsSaveButton
  },
  computed: {
    ...mapState("matching", [
      "loadingPivotItems",
      "pivotItems",
      "sidebarVisible"
    ])
  }
};
</script>

<style scoped>
.container.shrink {
  margin-left: 300px;
}
</style>
